import { render, staticRenderFns } from "./com_fun.vue?vue&type=template&id=5604c08e&scoped=true&"
import script from "./com_fun.vue?vue&type=script&lang=js&"
export * from "./com_fun.vue?vue&type=script&lang=js&"
import style0 from "./com_fun.vue?vue&type=style&index=0&id=5604c08e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5604c08e",
  null
  
)

export default component.exports